import { type FC } from 'react'

import { useSuntoryImport } from '../SuntoryImport'

import { ShipmentOrderCsvImportModalContentView } from './ShipmentOrderCsvImportModalContent.view'
import { type ImportHandoff, useImportHandoff } from './useImportHandoff'
import { useShipmentOrderCsvImport } from './useShipmentOrderCsvImport'

type Props = {
  tenantKey: string
  onClose: () => void
  /** 取り込み方法の画面に並べる、サントリー様の CSV の選択肢。 */
  handoffs?: readonly ImportHandoff[]
}

const NO_HANDOFFS: readonly ImportHandoff[] = []

/**
 * 配送依頼 CSVインポートのウィザード本体（配線のみ）。
 * ロジックは useShipmentOrderCsvImport・useImportHandoff・useSuntoryImport、表示は
 * ShipmentOrderCsvImportModalContentView が持つ（frontend-coding.md §1）。
 */
export const ShipmentOrderCsvImportModalContent: FC<Props> = ({
  tenantKey,
  onClose,
  handoffs = NO_HANDOFFS
}) => {
  const state = useShipmentOrderCsvImport(tenantKey)
  const handoff = useImportHandoff({
    handoffs,
    onChangeMethod: state.onChangeMethod
  })
  const suntory = useSuntoryImport({
    tenantKey,
    kind: handoff.selectedKind,
    onDone: onClose
  })
  return (
    <ShipmentOrderCsvImportModalContentView
      {...state}
      onChangeMethod={handoff.onChangeMethod}
      handoffs={handoff.handoffOptions}
      selectedHandoffKey={handoff.selectedHandoffKey}
      onSelectHandoff={handoff.onSelectHandoff}
      suntory={suntory}
      tenantKey={tenantKey}
      onClose={onClose}
    />
  )
}
